import { render, staticRenderFns } from "./ClipboardManager.vue?vue&type=template&id=41981a88&"
import script from "./ClipboardManager.vue?vue&type=script&lang=ts&"
export * from "./ClipboardManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports